export default __webpack_public_path__ + "static/media/splash_numbers_portrait.caac1523.png";